import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth, obj=user

  useEffect(() => {
    const token = localStorage.getItem("tembo_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => { localStorage.removeItem("tembo_token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem("tembo_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      const msg = e.response?.data?.detail || e.message || "Login failed";
      return { ok: false, error: typeof msg === "string" ? msg : JSON.stringify(msg) };
    }
  };

  const logout = () => {
    localStorage.removeItem("tembo_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
